import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

const TiptapMain = styled.div`
  position: relative;
  &.overflow-hidden {
    overflow: hidden;
  }

  .e-rte-video .e-video-inline {
    width: 355px !important;
  }

  .textblock {
    display: block;
    color: var(--text-primary);
    ${Typography.body_md}
  }
  .textblock > img {
    max-width: 100%;
    max-height: 100%;
    width: 300px;
    height: auto;
  }

  .text {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: var(--text-primary);
    ${Typography.body_md}
    .embed-icon {
      max-width: 14px;
      max-height: 14px;
      width: 14px;
      height: 14px;
      margin-top: 0;
      border: unset;
    }
    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
      padding: 0;
      ${Typography.body_md_medium}
    }
    img {
      max-width: 300px;
      max-height: 300px;
      width: auto;
      height: auto;
      margin: 0 auto;
      border: 0.5px solid var(--border-primary);
      border-radius: 8px;
      ${mobile_xl(css`
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
      `)}
    }
  }
  .e-rte-image.e-imginline {
    vertical-align: baseline;
  }
  .e-rte-video.e-video-inline {
    max-width: 354px;
  }

  .threaddiv {
    padding: 8px;
    border-radius: 8px;
    border: 0.5px solid var(--border-primary);
    background: var(--background-tertiary);
    width: 100%;
    max-width: fit-content;
  }
  .content {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
  .line {
    width: 1px;
    background-color: var(--text-placeholder);
    border: 0.5px solid var(--text-placeholder);
    height: auto;
    border-radius: 3px;
  }
  .rightdiv {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .header {
    display: flex;
    flex-direction: row;
    gap: 50px;
    justify-content: space-between;
  }
  .leftheader {
    display: flex;
    flex-direction: row;
    gap: 9px;
    align-items: center;
  }
  .rightheader {
    cursor: pointer;
    height: 18px;
    .svgicon {
      stroke: var(--text-primary);
      fill: var(--text-primary);
    }
    :hover {
      background-color: var(--neutral-secondary);
      border-radius: 4px;
    }
  }
  .name {
    color: var(--text-primary);
    ${Typography.body_md}
  }
  .time {
    color: var(--text-secondary);
    ${Typography.body_md}
  }

  .copy-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    background: var(--background-secondary);
    display: none;
  }

  /* Special margin for first table in the editor */
  .tiptap > div > .tableWrapper:first-child,
  .tiptap > .tableWrapper:first-child {
    margin-top: 30px;
  }
  .tiptap > p:first-child {
    margin: 0;
  }

  ${mobile_xl(css`
    .e-rte-image.e-imginline {
      padding: 0;
    }

    .text {
      word-break: break-all;
      p {
        img {
          width: 100%;
          border-radius: 4px;
        }
      }
    }
    .header {
      gap: 12px;
    }
    .threaddiv {
      max-width: -webkit-fill-available;
    }
    .rightdiv {
      gap: 4px;
      width: 100%;
    }

    .cleanshot-video-main-div {
      max-width: -webkit-fill-available;
    }

    .e-rte-video.e-video-inline {
      max-width: 100%;
    }
    .rightdiv {
      gap: 4px;
      word-break: break-all;
    }
    .leftheader {
      gap: 3px;
    }
    .document-embed-container {
      padding: 8px;
      gap: 8px;
    }
    .document-content {
      min-width: 0;
    }
    .file-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `)}
`;

const TableMainDiv = styled.div`
  display: flex;
  gap: 8px;
  max-width: 391px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  padding: 4px 4px 4px 12px;
  border-radius: 50px;
  position: absolute;
  /* z-index: 99; */
  pointer-events: all;
`;

const ButtonMainDiv = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  pointer-events: all;
  p {
    margin: 0;
    ${Typography.body_md}
    color: var(--text-secondary);
  }
`;

const IconDiv = styled.div`
  display: flex;
  padding: 4px;
  border-radius: 50px;
  cursor: pointer;
  pointer-events: all;
  svg {
    stroke: var(--text-secondary);
  }
  &:hover {
    background-color: var(--neutral-secondary);
    svg {
      stroke: var(--text-primary);
    }
    .header-icon {
      stroke: none;
      fill: var(--text-primary);
    }
  }
  .header-icon {
    stroke: none;
    fill: var(--text-secondary);
  }
`;

const Divider = styled.div`
  border: 0.5px solid var(--border-primary);
`;

const TipTapWrapperDiv = styled.div<{ applyPosition?: boolean }>`
  ${({ applyPosition }) =>
    applyPosition &&
    css`
      position: relative;
    `}
`;

export { TiptapMain, TableMainDiv, ButtonMainDiv, IconDiv, Divider, TipTapWrapperDiv };
